module.exports = __webpack_public_path__ + "static/media/debateImage2.cf31305c.png";